// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"st_a bhe_b bhe_bj","SubscribedPhotoblogs__link":"st_b bhe_a bhe_r"};